import { Box, SxProps, Theme } from '@mui/material';
import { walkthroughColors } from './walkthroughStyle';

/** Hand-drawn curly arrow pointing up-left, gently nudging towards what it points at. Its tip is 4px from its left edge. */
const CurlyArrow = ({ sx }: { sx?: SxProps<Theme> }) => (
  <Box
    component='svg'
    viewBox='0 0 70 56'
    sx={{
      display: 'block',
      width: 70,
      height: 56,
      ml: 1,
      color: walkthroughColors.highlight,
      animation: 'walkthroughNudge 1.6s ease-in-out infinite',
      '@keyframes walkthroughNudge': {
        '0%, 100%': { transform: 'translate(0, 0)' },
        '50%': { transform: 'translate(-3px, -3px)' }
      },
      ...sx
    }}
    aria-hidden
  >
    <path
      d='M60 54 C 62 34, 40 40, 34 30 C 28 20, 40 12, 30 10 C 22 8, 14 12, 8 6'
      fill='none'
      stroke='currentColor'
      strokeWidth='2.5'
      strokeLinecap='round'
    />
    <path d='M4 2 L 8 14 M4 2 L 16 4' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' />
  </Box>
);

export default CurlyArrow;
